/* LensAdvisor collection page — staggered scroll reveal for hero + catalog entries. */
(function () {
  const init = () => {
    const roots = document.querySelectorAll('.la-collection-page');
    if (!roots.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const targets = [];
    roots.forEach((root) => {
      root.querySelectorAll('.la-col-hero-head, .la-col-hero-meta, .la-col-head, .la-col-index-item, .la-col-gallery-item, .la-col-close-inner > div').forEach((el) => {
        if (!el.dataset.laReveal) {
          el.dataset.laReveal = '1';
          targets.push(el);
        }
      });
    });
    if (!targets.length) return;

    const io = new IntersectionObserver((entries) => {
      entries.forEach((e, idx) => {
        if (!e.isIntersecting) return;
        e.target.animate(
          [
            { opacity: 0, transform: 'translateY(14px)' },
            { opacity: 1, transform: 'translateY(0)' }
          ],
          {
            duration: 600,
            easing: 'cubic-bezier(0.2, 0.8, 0.2, 1)',
            fill: 'both',
            delay: Math.min(idx * 35, 240)
          }
        );
        io.unobserve(e.target);
      });
    }, { threshold: 0.1 });
    targets.forEach((el) => { el.style.opacity = '0'; io.observe(el); });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
